import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, Check, Loader2, Clapperboard, Play } from "lucide-react";
import AppShell from "@/components/AppShell";
import client from "@/lib/api";
import { useLang } from "@/context/LangContext";

export default function Stories() {
  const nav = useNavigate();
  const { t } = useLang();
  const [items, setItems] = useState(null);
  useEffect(() => { client.get("/learn/stories").then(({ data }) => setItems(data)).catch(() => setItems([])); }, []);
  return (
    <AppShell>
      <div className="pt-10 pb-1">
        <div className="flex items-center gap-2"><Clapperboard className="text-amber-500" /><h1 className="font-heading text-2xl font-extrabold tracking-tight text-[#0F172A]">{t("stories_title")}</h1></div>
        <p className="text-slate-500 mt-1 text-sm">{t("stories_sub")}</p>
      </div>
      {!items ? <div className="pt-20 flex justify-center"><Loader2 className="animate-spin text-[#2563EB]" /></div> : (
        items.length === 0 ? <p className="pt-16 text-center text-slate-400">{t("stories_empty")}</p> : (
          <div className="mt-4 space-y-4">
            {items.map((s) => (
              <button key={s.id} disabled={!s.unlocked} onClick={() => nav(`/story/${s.id}`)} data-testid={`story-${s.id}`}
                className={`w-full text-left rounded-3xl overflow-hidden border shadow-sm ${s.unlocked ? "border-slate-200 bg-white" : "border-slate-200 bg-slate-50"}`}>
                <div className="relative h-40">
                  <img src={s.cover} alt="" className={`w-full h-full object-cover ${s.unlocked ? "" : "grayscale opacity-60"}`} />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0F172A]/85 to-transparent" />
                  {s.status === "completed" && <span className="absolute top-3 right-3 w-7 h-7 rounded-full bg-emerald-500 text-white flex items-center justify-center"><Check size={16} /></span>}
                  {!s.unlocked && <span className="absolute top-3 right-3 w-7 h-7 rounded-full bg-black/40 text-white flex items-center justify-center"><Lock size={14} /></span>}
                  <div className="absolute bottom-0 p-4 text-white">
                    <p className="text-[10px] font-bold uppercase tracking-widest opacity-80">{s.series} · {t("stories_ep")} {s.episode}</p>
                    <p className="font-heading text-lg font-extrabold">{s.title}</p>
                    <p className="text-xs opacity-90">{s.minutes} {t("common_min")}</p>
                  </div>
                  {s.unlocked && <span className="absolute inset-0 flex items-center justify-center"><span className="w-14 h-14 rounded-full bg-white/90 flex items-center justify-center"><Play className="text-[#2563EB] ml-1" size={26} /></span></span>}
                </div>
              </button>
            ))}
          </div>
        )
      )}
    </AppShell>
  );
}
